
import { DexAssessmentController } from "@/app/ui/controllers/DexAssessmentController";
import { Options, Vue } from "vue-class-component";
import SectionTableExpand from "../components/section-table-expand.vue";
import { OptionsClass } from "@/domain/entities/MainApp";
import { PodDexController } from "@/app/ui/controllers/PodDexController";
import { ReasonListDex } from "@/data/payload/api/PodDexRequest";
import { ReasonData } from "@/domain/entities/PodDex";
import Checkbox from "primevue/checkbox";
import SectionSummaryByReason from "../components/section-summary-by-reason.vue";
import SectionTicketPerDay from "../components/section-ticket-per-day.vue";

@Options({
  components: {
    SectionTableExpand,
    Checkbox,
    SectionSummaryByReason,
    SectionTicketPerDay
  }
})
export default class SectionBreakdownTicketDexDispute extends Vue {
  mounted(): void {
    this.fetchReason();
    Object.assign(this.filter, { orderBy: new OptionsClass() });
  }

  get filter() {
    return DexAssessmentController.filter;
  }

  // reason
  async fetchReason() {
    await PodDexController.getReasonList(
      new ReasonListDex({
        statusCode: "DEX",
        reasonStatus: "active"
      })
    );
  }
  get reasonData(): OptionsClass[] {
    return PodDexController.reasonList.map(
      (key: ReasonData) =>
        new OptionsClass({
          name: key.reasonDescription,
          value: key.reasonCode
        })
    );
  }
  get totalReasonValue(): string {
    if (this.filter.reasonCode.length) {
      return this.$t("dexAssessment.totalReasonFormat", {
        count: this.filter.reasonCode.length
      });
    }
    return "";
  }

  onFetchSummaryBreakdownTicketDex() {
    this.filter.clickFilter = true;
    this.fetchSummaryTopDex();
    this.fetchTotalTicketPerDay();
  }

  async fetchTotalTicketPerDay() {
    const refs: any = this.$refs["total-ticket"];
    if (refs) {
      refs.fetchData();
    }
  }

  async fetchSummaryTopDex() {
    const refs: any = this.$refs["table-expand"];
    const byReasonRefs: any = this.$refs["by-reason"];
    if (refs) {
      refs.fetchSummaryTopDex("partner");
      byReasonRefs.fetchData();
    }
  }

  onDownload() {
    DexAssessmentController.filter.type = "dispute";
    DexAssessmentController.getDownload("summary-breakdown-download");
  }
}
